import { render } from "./SecretList.vue?vue&type=template&id=4d830170&ts=true"
import script from "./SecretList.vue?vue&type=script&lang=ts"
export * from "./SecretList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__